export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-4.png?9460161f94f63959520f0051c5c631a2";